import { MutationTree } from 'vuex';
import { SATISFACTION } from './mutation-types';
import { SatisfactionState } from './state';
import { SatisfactionDTO } from '@/models/Satisfaction';

export const mutations: MutationTree<SatisfactionState> = {
    [SATISFACTION.SET_SOCIETES](state: SatisfactionState, societes: []): void {
        state.societes = societes;
    },
    [SATISFACTION.SET_SOCIETE_SELECTIONNEE](state: SatisfactionState, societeId: number): void {
        state.societeIdSelectionnee = societeId;
    },
    [SATISFACTION.SET_SATISFACTION](state: SatisfactionState, satisfactionDTO: SatisfactionDTO): void {
        state.satisfaction = satisfactionDTO;
    },
};
